<template>
  <div class="loader">
    <span class="loader__circle"></span>
    <span class="loader__circle"></span>
    <span class="loader__circle"></span>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
.loader {
  display: flex;
  justify-content: center;
  padding: .9rem 0;
  &__circle {
    width: $loader-circle-size;
    height: $loader-circle-size;
    border-radius: 50%;
    margin: $loader-circle-margin;
    background: $loader-circle-color;
    animation: scaleInOut 2s cubic-bezier(.645, .045, .355, 1) infinite;
    @for $i from 1 through 3 {
      &:nth-of-type(#{$i}) {
        animation-delay: $i * 0.1s;
      }
    }
  }
}
@keyframes scaleInOut {
  20% {
    transform: scale(0);
  }
  0%, 40%, 100% {
    transform: scale(1);
  }
}
</style>

<docs>
  ```jsx
    <div>
      <loader />
    </div>
  ```
  ```scss
  // Variable defaults:
  $loader-circle-size: rem(6);
  $loader-circle-margin: 0 rem(3);
  $loader-circle-color: color(dark, 0.2);
  ```
</docs>
